export default {
    OPEN: "Открыть",
    DUPLICATE: "Дублировать",
    EDIT: "Редактировать",
    DELETE: "Удалить",
    CONFIRM_DELETE_TEXT: "Вы уверены, что хотите удалить этот документ?",
    CONFIRM_DELETE_HEADER: "Удалить документ"
};
